import { useEffect, useLayoutEffect } from 'react';
/**
 * 当前处于客户端
 */
export var IS_CLIENT = true;
export var useClientLayoutEffect = IS_CLIENT ? useLayoutEffect : useEffect;